import mutations from "./mutations.js";
import actions from "./actions.js";
import getters from "./getters.js";

export default {
  state() {
    return {
      productId: null,
      address: null,
      personalInformation: null,
      bankAccount: null,
      fundSelection: null,
      fundAllocation: null
    };
  },
  mutations,
  actions,
  getters,
};
